/* eslint-disable */
const reportsUrls = {
  'docket-detail': { fileNamePrefix: `DocketDetail`, i18nKey: `DocketReportPage`, pageTitle: `Docket Detail Report`, type: `DELIVERY_DOCKET_DETAIL_REPORT` },
  volume: { fileNamePrefix: `DocketQuantity`, i18nKey: `ReportPage`, pageTitle: `Volume Report`, type: `VOLUME_REPORT` },
};

export default reportsUrls;
